<template>
  <div class="design justify-between">
    <div class="design-left">
      <div class="justify-center justify-between">
        <div class="item flex-col justify-center items-center">
          <svg-icon class="font40" icon-class="link"></svg-icon>
          <span>Website</span>
          <h3>官網</h3>
        </div>
        <div class="item flex-col justify-center items-center">
          <svg-icon class="font40" icon-class="youtube"></svg-icon>
          <span>Youtube</span>
          <h3>粉絲專頁</h3>
        </div>
      </div>
      <div class="justify-center justify-between">
        <div class="item flex-col justify-center items-center">
          <svg-icon class="font40" icon-class="facebook-black"></svg-icon>
          <span>Facebook</span>
          <h3>粉絲專頁</h3>
        </div>
        <div class="item flex-col justify-center items-center">
          <svg-icon class="font40" icon-class="magazine"></svg-icon>
          <span>Member</span>
          <h3>會員中心</h3>
        </div>
      </div>
    </div>
    <div class="design-right">
      <div class="logo flex-col items-center">
        <svg-icon icon-class="logo-red"></svg-icon>
        <h3>雜誌購買</h3>
        <span>Buy</span>
      </div>
      <img
        class="bg"
        :src="`${imgUrl}/profile/upload/2023/12/13/微信图片_20231213175053_20231213175148A097.jpg`"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "aa",
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style  lang="less" scoped>
.design-left {
  background: #dc000c;
  padding: 40px;
  flex: 1;
  height: 100%;
  width: 66%;
  .item {
    background: #fff;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    width: 48%;
    .svg-icon {
      font-size: 80px;
    }
    span {
      font-family: NotoSansCJKTC;
      font-weight: 700;
      line-height: 1.71;
      letter-spacing: 0.7px;
      font-size: 20px;
      color: #8b8b8b;
      margin-top: 8px;
    }
    h3 {
      font-family: NotoSansCJKTC;
      font-weight: 700;
      line-height: 1.67;
      letter-spacing: 2.7px;
      margin-top: 12px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      font-size: 30px;
    }
  }
}
.design-right {
  width: 34%;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0.3;
  }
  .logo {
    padding: 40px;
    .svg-icon {
      font-size: 180px;
    }
    h3 {
      font-family: NotoSansCJKTC;
      font-weight: 500;
      letter-spacing: 2px;
      margin-bottom: 13px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      font-size: 40px;
    }
    span{
      font-family: NotoSansCJKTC;
      font-weight: 700;
      line-height: 1.71;
      letter-spacing: 0.7px;
      font-size: 30px;
      color: #222;
      margin-top: 8px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/aa/index.vue